import { Link } from "react-router-dom"
import { getRoute, getRouteByComponent } from "src/libs/layouts"
import PeriodLabel from "src/libs/useful/PeriodLabel"
import Shortcode from "src/libs/useful/shortcode"
import { wordTrim } from "src/libs/utilities"
import { ILand } from "src/modules/pe-fest-module/data/interfaces"
import EventTypeLabel from "../labels/EventTypeLabel"

interface IProps {
    item: ILand
    height?: number | string
    width? : number // only percentage (100% or 33%)
}
const EventCard = (props: IProps) : JSX.Element => {
    // const routeSingle = getSingleRoute("Event") 
    // const url = routeSingle ? `/${routeSingle.route}/${props.item.id}` : "/" 
    const url = `/${getRoute( getRouteByComponent("FestivalView")! )}fest/${props.item?.id}`

    const content = wordTrim( ( props.item.content || "" ).replace(/<\/?(img|tr|td|ul|li)[^>]*(>|$)/gi,'').replace( /\[PE_(.*?)(\/\]|\[\/PE_(.*?)\])/gi, "" ), 40 ) 
    return <Link to={url} className={`w-${props.width || "100"} h-100 card rounded-0 p-0`} > 
        <div 
            className="thumbnail card-top-img" 
            style={{ 
                backgroundImage:`url(${props.item.defaultThumbnail})`, 
                height: props.height 
            }} 
        >
            <EventTypeLabel isShort item={ props.item } className="position-absolute small flex-wrap mx-1 my-1 z-index-10"/>
            <div className="position-absolute bottom left w-100 z-index-10 pb-4 text-force-contrast text-center ">
                <div className="h lead-md">
                    {props.item.title}
                </div>
                <div className="small descr text-force-contrast opacity_75">{props.item.description}</div> 
                <Shortcode content={ content } className="card-top-content small px-3" />
            </div>           
        </div>
        <div className="small m-1 position-absolute top right small">
            <PeriodLabel 
                start_date={ Number(props.item.startDate) || 0} 
                finish_date={Number(props.item.finishDate) || 0} 
                className="small" 
                labelClassName="small"
            />
        </div>
        <div className="card-body d-none">
            
        </div> 
    </Link>
} 

export default EventCard